module.exports = __webpack_public_path__ + "static/media/LokiFrame87.baf59746.png";